import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useCallback } from 'react';
import { useEventListener } from '@beef/react';
import { getCurrentBreakpoint, simulateResize } from "./helpers";

/**
 * Update each time a resolution changes
 */
export var useAdaptiveSize = function useAdaptiveSize(breakpoints) {
  var _React$useState = React.useState(getCurrentBreakpoint(breakpoints, 1000)),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    breakpoint = _React$useState2[0],
    setBreakpoint = _React$useState2[1];
  var updateBreakpoint = useCallback(function () {
    /** set `breakpoint` to closest of `breakpoints` that screen surpassed in width */
    var currentBreakpoint = getCurrentBreakpoint(breakpoints);
    if (currentBreakpoint !== breakpoint) {
      setBreakpoint(currentBreakpoint);
      setTimeout(simulateResize);
    }
  }, [breakpoints, breakpoint, setBreakpoint]);
  useEventListener('resize', updateBreakpoint, typeof window !== 'undefined' ? window : null);
  React.useEffect(updateBreakpoint, [breakpoints, updateBreakpoint]);
  return breakpoint;
};